import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Input from './Input.js';

function PasswordInput(_ref) {
  var placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    hasError = _ref.hasError,
    value = _ref.value,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    errorMessage = _ref.errorMessage,
    maxLength = _ref.maxLength,
    disableLabelAnimation = _ref.disableLabelAnimation,
    focus = _ref.focus,
    disableAutofill = _ref.disableAutofill,
    autoComplete = _ref.autoComplete,
    inputMode = _ref.inputMode,
    focusAndScrollIntoView = _ref.focusAndScrollIntoView,
    scrollIntoVIew = _ref.scrollIntoVIew;
  var _useState = useState(disableAutofill ? 'text' : 'password'),
    _useState2 = _slicedToArray(_useState, 2),
    inputType = _useState2[0],
    setInputType = _useState2[1];
  var _useState3 = useState(disableAutofill),
    _useState4 = _slicedToArray(_useState3, 2),
    disableAutofillStyle = _useState4[0],
    setDisableAutofillStyle = _useState4[1];
  var _useState5 = useState('icon-show_password'),
    _useState6 = _slicedToArray(_useState5, 2),
    viewPasswordIcon = _useState6[0],
    setViewPasswordIcon = _useState6[1];
  var toggleVisibility = function toggleVisibility() {
    if (disableAutofill) {
      setDisableAutofillStyle(!disableAutofillStyle);
    } else {
      var newInputType = inputType === 'password' ? 'text' : 'password';
      setInputType(newInputType);
      var hidePasswordIcon = viewPasswordIcon === 'icon-show_password' ? 'icon-hide_password' : 'icon-show_password';
      setViewPasswordIcon(hidePasswordIcon);
    }
  };
  useEffect(function () {
    if (disabled && !disableAutofill) {
      setInputType('password');
    }
    if (disabled && disableAutofill) {
      setDisableAutofillStyle(true);
    }
  }, [disabled]);
  return /*#__PURE__*/React.createElement(Input, {
    placeholder: placeholder,
    icon: viewPasswordIcon,
    type: inputType,
    maxLength: maxLength,
    value: value,
    hasError: hasError,
    errorMessage: errorMessage,
    disabled: disabled,
    onChange: onChange,
    onClick: onClick,
    onIconClick: toggleVisibility,
    className: className,
    dataTestId: dataTestId,
    disableLabelAnimation: disableLabelAnimation,
    focus: focus,
    autoComplete: autoComplete,
    disableAutofill: disableAutofillStyle,
    inputMode: inputMode,
    scrollIntoVIew: scrollIntoVIew,
    focusAndScrollIntoView: focusAndScrollIntoView
  });
}
PasswordInput.propTypes = {
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  errorMessage: PropTypes.string,
  maxLength: PropTypes.number,
  disableLabelAnimation: PropTypes.bool,
  focus: PropTypes.bool,
  autoComplete: PropTypes.string,
  disableAutofill: PropTypes.bool,
  inputMode: PropTypes.string,
  scrollIntoVIew: PropTypes.bool,
  focusAndScrollIntoView: PropTypes.bool
};
PasswordInput.defaultProps = {
  hasError: false,
  value: '',
  disabled: false,
  onClick: function onClick() {},
  className: '',
  dataTestId: null,
  errorMessage: '',
  maxLength: 4,
  disableLabelAnimation: false,
  focus: false,
  autoComplete: 'off',
  disableAutofill: false,
  inputMode: 'text',
  scrollIntoVIew: false,
  focusAndScrollIntoView: false
};

export { PasswordInput as default };
